import { render, staticRenderFns } from "./BuyapowaRefer.vue?vue&type=template&id=de297a4e&"
import script from "./BuyapowaRefer.vue?vue&type=script&lang=js&"
export * from "./BuyapowaRefer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports